import clsx from 'clsx'
import React, { FC, useContext } from 'react'

import SvgPhone from '@Assets/SVG/Phone'
import SvgPhone2 from '@Assets/SVG/Phone2'
import SvgReturn2 from '@Assets/SVG/Return2'
import SvgReturnOrder2 from '@Assets/SVG/ReturnOrder2'
import SvgTruck2 from '@Assets/SVG/Truck2'
import SvgTruckRound from '@Assets/SVG/TruckRound'
import { TRUST_PILOT_WIDGET_TEMPLATE_MICRO_STAR, TrustPilotWidget } from '@Components/TrustPilotWidget'
import { OrderBeforeText } from '@Domains/Checkout/Footer/OrderBeforeText'
import { MetadataContext } from '@Globals/Metadata'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

import styles from './FooterTrustpilotAndDelivery.module.scss'

export const FooterTrustpilotAndDelivery: FC = () => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')
  const { t } = useTranslation()
  const { store } = useContext(MetadataContext)
  const useExtendedReturnV1 = useSplitTest('extended_return_v1', 'b')

  const phone = store?.config?.phone

  let trustLogo = ''
  let trustText = ''

  // Get trust logo and text based on store
  switch (store.id) {
    case '7':
      // DE
      trustLogo += 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt3b30b87a9b34b1e6/trusted-shops-logo.png'
      trustText = 'Zertifiziert von Trusted Shops'
      break
    case '10':
      // FR
      trustLogo += 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt3b30b87a9b34b1e6/trusted-shops-logo.png'
      trustText = 'Certification par Trusted Shops'
      break
    case '19':
      // CH_DE
      trustLogo += 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt7e60be22df067f31/swiss-online-guarantee-logo.png'
      trustText = 'Mitglied des Schweizer Versandhandelsverbandes.'
      break
    case '20':
      // CH_FR
      trustLogo += 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt7e60be22df067f31/swiss-online-guarantee-logo.png'
      trustText = 'Membre de VSV'
      break
    default:
      break
  }

  if (cofDesignV1) {
    return (
      <footer className={clsx(styles.footerWrapper, styles.footerWrapper2)}>
        <div
          className={styles.trustPilotWrapper}
          onClick={e => e.stopPropagation()}
        >
          <TrustPilotWidget className={styles.trust} link={false} trustPilotWidgetTemplate={TRUST_PILOT_WIDGET_TEMPLATE_MICRO_STAR} />
        </div>
        <div className={styles.infoItem}>
          <SvgPhone2 />
          <p>
            <strong>{`${t('checkout:COF_NEED_HELP')} `}</strong>
            <a href={`tel:${phone}`}>{phone}</a>
          </p>
        </div>
        <div className={styles.infoItem}>
          <SvgReturn2 />
          <p>{t('header:RETURN_POLICY_365_DAYS', { context: useExtendedReturnV1 ? 'extended' : undefined })}</p>
        </div>
        <div className={styles.infoItem}>
          <SvgTruck2 />
          <p><OrderBeforeText /></p>
        </div>
        <span className={styles.emblemWrapper}>
          {trustLogo && trustText && (<img alt={trustText} src={trustLogo} />)}
        </span>
      </footer>
    )
  }

  return (
    <footer className={styles.footerWrapper}>
      <span
        className={styles.trustPilotWrapper}
        onClick={e => e.stopPropagation()}
      >
        <TrustPilotWidget trustPilotWidgetTemplate={TRUST_PILOT_WIDGET_TEMPLATE_MICRO_STAR} />
      </span>
      <div className={clsx(styles.infoItem, styles.help)}>
        <SvgPhone className={styles.phoneIcon} />
        <p>
          {`${t('checkout:COF_NEED_HELP')} `}
          <br />
          <a href={`tel:${phone}`}>{phone}</a>
        </p>
      </div>
      <div className={clsx(styles.infoItem, styles.policy)}>
        <SvgReturnOrder2 />
        <p>{t('header:RETURN_POLICY_365_DAYS', { context: useExtendedReturnV1 ? 'extended' : undefined })}</p>
      </div>
      <div className={clsx(styles.infoItem, styles.orderBefore)}>
        <SvgTruckRound />
        <p><OrderBeforeText /></p>
      </div>
      <span className={styles.emblemWrapper}>
        {trustLogo && trustText && (<img alt={trustText} src={trustLogo} />)}
      </span>
    </footer>
  )
}
